import { AlertTriangle } from 'lucide-react';
import FotoEvidencia from './FotoEvidencia';
import { MAX_FOTOS_PERGUNTA } from './evidenciaUtils';

// Bloco de evidência de UMA pergunta respondida "Não" — usado pelos dois
// questionários (Avaliação de Segurança do Alimento e Avaliação de
// Treinamento — ex-Auditoria SA/TSV).
//
// Só aparece na negativa: é ela que precisa de prova. Em "Sim"/"N/A" a
// observação segue livre, como sempre foi.
//
// A ordem dos elementos é a do trabalho em campo: o auditor viu o problema,
// fotografa, e escreve o que a loja tem de corrigir.

const BlocoEvidencia = ({
  api,            // '/api/avaliacao' | '/api/auditoria'
  chave,          // 'D12', 'FS9'…
  observacao,
  onObservacao,   // (texto) => void
  urls = [],      // fotos já enviadas desta pergunta
  onUrls,         // (novoArray) => void
  meta,           // { loja, data, chave: sessão }
  bloqueado,      // sem loja/data ainda
}) => {
  const fotos = urls.filter((u) => u && String(u).trim());
  const faltaFoto = fotos.length === 0;
  const faltaObservacao = String(observacao || '').trim() === '';

  // Slots visíveis: os já preenchidos + UM livre (até o teto). Mostrar os três
  // de uma vez sugeriria que as três são obrigatórias.
  const slots = Math.min(fotos.length + 1, MAX_FOTOS_PERGUNTA);

  const trocarFoto = (indice, url) => {
    const novo = [...urls];
    novo[indice] = url;
    onUrls(novo.filter((u, i) => u || i < novo.length - 1));  // remove o buraco do fim
  };

  return (
    <div style={{
      marginTop: 10, padding: '12px 14px', borderRadius: 8,
      background: '#fff7ed', border: '1px solid #fed7aa',
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10,
        fontSize: 12, fontWeight: 700, color: '#9a3412',
      }}>
        <AlertTriangle size={14} />
        Resposta "Não": foto e observação são obrigatórias
      </div>

      {/* Fotos */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
        {Array.from({ length: slots }).map((_, i) => (
          <FotoEvidencia
            key={i}
            api={api}
            url={urls[i] || ''}
            onUrl={(url) => trocarFoto(i, url)}
            meta={{ ...meta, pergunta: chave, ordem: i + 1 }}
            desabilitado={bloqueado}
          />
        ))}
        {faltaFoto && (
          <span style={{ fontSize: 11, color: '#b91c1c', fontWeight: 600 }}>
            {bloqueado ? 'Preencha loja e data no topo para anexar' : 'Anexe ao menos 1 foto'}
          </span>
        )}
        {fotos.length >= MAX_FOTOS_PERGUNTA && (
          <span style={{ fontSize: 11, color: '#78716c' }}>máximo de {MAX_FOTOS_PERGUNTA} fotos</span>
        )}
      </div>

      {/* Observação — obrigatória aqui, com a borda avisando enquanto vazia */}
      <textarea
        id={`${chave}-obs`}
        value={observacao || ''}
        onChange={(e) => onObservacao(e.target.value)}
        placeholder="Descreva o que está fora do padrão e o que a loja precisa corrigir"
        aria-label={`Observação obrigatória da pergunta ${chave}`}
        style={{
          width: '100%', marginTop: 10, padding: '10px 12px', borderRadius: 6,
          fontSize: 13, fontFamily: 'inherit', resize: 'vertical', minHeight: 62,
          border: `1px solid ${faltaObservacao ? '#fca5a5' : '#cbd5e1'}`,
          background: '#fff',
        }}
      />
    </div>
  );
};

export default BlocoEvidencia;
